import { FormikValues } from "formik";
import { DraftBase } from "../types";

export const DRAFT_BASE_MISMATCH_ERRORS = [
  "EmailMismatchException",
  "DraftCuitMismatchException",
  "ReferrerMismatchException",
];

export const getDraftReferrer = (values?: FormikValues | null) => {
  const { referredBool, referrer } = values ?? {};
  if (referredBool === "NO" || referredBool === false) return undefined;
  if (typeof referrer !== "string" || !referrer.trim()) return undefined;
  if (referrer.includes("@") || referrer.toLowerCase().startsWith("sav3"))
    return referrer;
  return referrer.replace(/\+/g, " ");
};

export const buildDraftBase = ({
  cuit,
  referrer,
  juridicalPersonCuit,
}: {
  cuit: string;
  referrer?: string | null;
  juridicalPersonCuit?: string | null;
}): DraftBase => ({
  cuit,
  ...(referrer ? { referrer } : {}),
  ...(juridicalPersonCuit ? { juridicalPersonCuit } : {}),
});

export const getDraftBase = (values: FormikValues): DraftBase =>
  buildDraftBase({
    cuit: values.cuit,
    referrer: getDraftReferrer(values),
    juridicalPersonCuit: values.businessInformation?.cuit,
  });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDraftBaseFromSteps = (steps: any[] = []): DraftBase | null => {
  const findStep = (type: string) =>
    steps.find((step) => step?.["@type"] === type);

  const physical = findStep("1_PHYSICAL");
  const juridical = findStep("1_JURIDICAL");
  const securities = findStep("1_SECURITY");
  const business = findStep("2_JURIDICAL");

  const cuit =
    physical?.personalInformation?.cuit ??
    juridical?.representativeInformation?.cuit ??
    securities?.taxNumber;

  if (!cuit) return null;

  return buildDraftBase({
    cuit,
    referrer: (physical ?? juridical ?? securities)?.referrer,
    juridicalPersonCuit: business?.businessInformation?.cuit,
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDraftBaseMismatchError = (data: any) =>
  [data?.code, data?.error, data?.exception].some((value) =>
    DRAFT_BASE_MISMATCH_ERRORS.includes(value),
  );
